'use client';
import type { ReactNode } from 'react';
import { createContext, memo, useContext } from 'react';
import type { ReactZoomPanPinchProps } from 'react-zoom-pan-pinch';
import { TransformWrapper } from 'react-zoom-pan-pinch';

// TransformWrapper re-runs `update(props)`, a forced layout, on every render. It recalculates bounds on each
// pan/zoom anyway, so it only re-renders on config changes and the content reaches it through context.
const ZoomContentContext = createContext<ReactNode>(null);

const ZoomContent = () => useContext(ZoomContentContext);

const zoomContent = <ZoomContent />;

type ZoomConfig = Omit<ReactZoomPanPinchProps, 'children'>;

const MemoizedTransformWrapper = memo(function MemoizedTransformWrapper(config: ZoomConfig) {
  return <TransformWrapper {...config}>{zoomContent}</TransformWrapper>;
});

export const ZoomableContainer = ({ children, ...config }: ZoomConfig & { children: ReactNode }) => (
  <ZoomContentContext.Provider value={children}>
    <MemoizedTransformWrapper {...config} />
  </ZoomContentContext.Provider>
);
